export enum OrgNameMapping {
  Default = 'default',
  Lennar = 'lennar',
  Toll = 'toll_brothers',
  Khov = 'khov',
  Mattamy = 'mattamy',
  Hbia = 'hbia',
}
